function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 85.331h512v341.326H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M330.207 85.331H512v341.337H330.207zM0 85.331h181.793v341.337H0z",
  fill: "#a2001d"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#ffda44"
}, /*#__PURE__*/React.createElement("path", {
  d: "M113.163 267.125h14.84v59.359h-14.84zm-59.37 0h14.84v59.359h-14.84z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90.902,
  cy: 289.386,
  r: 14.84
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90.902,
  cy: 237.44,
  r: 7.421
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.054 311.647h29.682v14.84H76.054zm0-59.359h29.682v14.84H76.054zm14.843-66.786l5.255 16.173h17.006l-13.757 9.996 5.252 16.173-13.756-9.996-13.756 9.996 5.251-16.173-13.756-9.996h17.005z"
}));

const SvgMongolia = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMongolia, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mongolia.603ce223.svg";
export { ForwardRef as ReactComponent };